<template>
  <v-card class="mt-3" flat>
    <v-sheet class="d-flex justify-space-between align-center px-2">
      <v-slide-group v-model="tag" mandatory show-arrows style="flex: 1; max-width: calc(100% - 80px)">
        <v-slide-item v-for="item in tags" v-slot="{ active, toggle }" :key="item.id" class="ma-2">
          <v-btn :color="active ? '#d9bddd' : 'white'" class="mx-1 rounded-1" :class="active ? 'active' : 'not-selected'" depressed :elevation="0" @click="toggle" small>{{
            $t(`tags.${item.id}`)
          }}</v-btn>
        </v-slide-item>
      </v-slide-group>

      <!-- 그리드 뷰 토글 -->
      <div class="d-flex ml-2" style="flex-shrink: 0">
        <v-btn icon small @click="gridCols = 2" :color="gridCols === 2 ? 'primary' : 'grey'">
          <v-icon small>mdi-view-grid</v-icon>
        </v-btn>
        <v-btn icon small @click="gridCols = 3" :color="gridCols === 3 ? 'primary' : 'grey'" class="ml-1">
          <v-icon small>mdi-view-module</v-icon>
        </v-btn>
      </div>
    </v-sheet>

    <v-row v-if="list.length" no-gutters>
      <v-col v-for="(item, index) in list" :key="item.id" :cols="gridCols === 3 ? 4 : 6" class="py-2" :class="getColClass(index)">
        <v-card :to="'/castle/' + item.id" flat>
          <!-- 이미지 -->
          <v-img :lazy-src="require('@/assets/placeholder.jpg')" :src="'/upload/concept/thumbnail_image/' + item.pattern_1_image" position="top center" :aspect-ratio="2.5 / 3">
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0 align-center" justify="center">
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-row>
            </template>
          </v-img>
          <v-sheet class="d-flex flex-column flex-md-row justify-start justify-md-end align-start align-md-center mt-1 mt-md-2 px-2">
            <!-- tag (2열일 때만 표시) -->
            <div v-if="gridCols === 2" class="d-flex flex-wrap mt-1 mb-md-0">
              <div v-for="tag in getTags(item.tag)" :key="tag" class="d-inline-flex">
                <v-chip style="margin-left: 1px; padding-left: 4px; padding-right: 4px" color="grey" :ripple="false" label outlined x-small pill>{{ getConceptTagStr(tag) }}</v-chip>
              </div>
            </div>
            <span class="px-1 px-sm-2 text-caption text-sm-body-2" style="color: #545454; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 100%">{{ getTitle(item) }}</span>
            <!-- <span class="pl-1 pl-sm-2 text-caption text-sm-body-2" color="grey">{{ $toComma(item.price) }}원</span> -->
          </v-sheet>
        </v-card>
      </v-col>
    </v-row>
    <v-sheet v-if="!list.length" class="d-flex justify-center align-center font-weight-medium" style="min-height: 100px"> {{ $t("page.conceptbooth.concept_not_exists") }} </v-sheet>
  </v-card>
</template>
<script>
import { AllTag, Tags } from "@/constant"
import { mapActions, mapState } from "vuex"

export default {
  props: {
    productType: {
      type: String,
      default: "makershot",
      validator: (value) => ["makershot", "premium"].includes(value),
    },
  },
  data: () => ({
    tags: [AllTag, ...Tags],
    list: [],
    category: "무인촬영",
    tag: null,
    gridCols: 2, // 2열 또는 3열

    loading: false,
  }),
  computed: {
    ...mapState(["lang"]),
  },
  mounted() {
    this.load()
  },
  watch: {
    async category() {
      await this.load()
    },

    async tag() {
      await this.load()
    },

    async productType() {
      await this.load()
    },
  },
  methods: {
    ...mapActions(["loadConcepts"]),
    // 목록 불러오기
    load() {
      // productType을 파라미터로 전달하여 필터링된 데이터 가져오기
      this.$http
        .post("/api/concept/select", {
          params: {
            productType: this.productType,
          },
        })
        .then((res) => {
          if (res.data.length) {
            this.list = res.data

            // 태그 필터링
            if (this.tag !== 0) {
              const tagStr = this.tags[this.tag].title
              this.list = this.list.filter((e) => e.tag && e.tag.includes(tagStr))
            }
          }
        })
        .catch((err) => {
          console.error("Failed to load concepts:", err)
        })
    },

    getTags(tagStr) {
      if (!tagStr) {
        return []
      }
      return tagStr.split(",")
    },

    getConceptTagStr(tag) {
      const tagKey = Tags.find((t) => t.title === tag).id
      return tagKey ? this.$t(`tags.${tagKey}`) : tag
    },

    getTitle(item) {
      switch (this.lang) {
        case "en":
          return item.title_en || item.title
        case "jp":
          return item.title_jp || item.title
        default:
          return item.title
      }
    },

    getColClass(index) {
      if (this.gridCols === 3) {
        // 3열일 때
        if (index % 3 === 0) return "pr-1"
        if (index % 3 === 1) return "px-1"
        return "pl-1"
      } else {
        // 2열일 때
        return index % 2 === 0 ? "pr-1" : "pl-1"
      }
    },
  },
}
</script>
<style scoped>
::v-deep .v-slide-group__prev,
::v-deep .v-slide-group__next {
  min-width: 20px !important;
}
::v-deep .v-slide-group__content {
  justify-content: center;
}
.v-btn {
  border: 2px solid rgb(223, 223, 223) !important;
}
.active {
  color: black;
}
.not-selected {
  color: rgb(141, 141, 141);
}

.guide {
  position: relative;
  margin-left: auto;
  margin-right: auto;
  width: 96%;
  height: 360px;
  aspect-ratio: 2.4;
  background-image: url("~@/assets/concept/concept_border.png");
  background-size: contain;
}

.guide.small {
  height: 260px !important;
}

.lucid-card {
  background-size: cover;
  background-image: url("~@/assets/concept/lucid-card.png");
  background-size: 90%;
  background-position: 50% 10%;
}

.lucid-card .desc {
  background-color: transparent;
  margin-top: 90px;
}

.lucid-card .desc.small {
  margin-top: 62px !important;
}

.lucid-card.small {
  background-position: 50% 12%;
}
</style>
